/**
 * Reloj digital en tiempo real con versión compacta para header
 */

import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { RELOJ_INTERVAL } from '../../constants';

const Reloj = ({ compact = false }) => {
    const [time, setTime] = useState(new Date());

    useEffect(() => {
        const intervalTime = setInterval(() => {
            setTime(new Date());
        }, RELOJ_INTERVAL);

        return () => clearInterval(intervalTime);
    }, []);

    const timeString = time.toLocaleTimeString('es-ES', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    const dateString = time.toLocaleDateString('es-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    // Versión compacta para header
    if (compact) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 0.75
                }}
            >
                <Typography
                    sx={{
                        fontFamily: '"Roboto Mono", monospace',
                        fontWeight: 800,
                        fontSize: { xs: '2.5rem', md: '3rem' },
                        color: 'white',
                        letterSpacing: 3,
                        lineHeight: 1,
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                    }}
                >
                    {timeString}
                </Typography>
                <Typography
                    sx={{
                        color: 'rgba(255,255,255,0.95)',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        fontSize: { xs: '1.05rem', md: '1.2rem' },
                        letterSpacing: 1
                    }}
                >
                    {dateString}
                </Typography>
            </Box>
        );
    }

    // Versión normal (standalone)
    return (
        <Box
            sx={{
                mt: 6,
                mb: 4,
                p: 4,
                textAlign: 'center',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                borderRadius: 4,
                border: '2px solid #e9ecef',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                maxWidth: 600,
                mx: 'auto'
            }}
        >
            {/* Hora digital */}
            <Typography
                variant="h1"
                sx={{
                    fontFamily: '"Roboto Mono", monospace',
                    fontWeight: 700,
                    fontSize: { xs: '3.5rem', sm: '4.5rem', md: '5.5rem' },
                    color: '#212529',
                    letterSpacing: 4,
                    lineHeight: 1.2,
                    textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
                    mb: 1
                }}
            >
                {timeString}
            </Typography>

            {/* Fecha */}
            <Typography
                variant="h6"
                sx={{
                    color: '#6c757d',
                    fontWeight: 500,
                    textTransform: 'capitalize',
                    fontSize: '1.1rem',
                    letterSpacing: 0.5
                }}
            >
                {dateString}
            </Typography>
        </Box>
    );
};

export default Reloj;
